import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {cloneDeep} from 'lodash';
import {
    CANDIDATE_CATEGORY_FIELDS,
    LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY, ResponseCode
} from "@app/constants/Common";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import {requestCandidates} from "@app/services/CandidateService";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestStartRunJob} from "@app/services/JobService";
import {
    requestAddCddToFollowUpTabDVTJCUV,
    requestCheckFollowUpDVTJCUV,
    requestStartRunDVTJCUV
} from "@pages/dvtjcuv/service/DVTJCUVService";
import {toast} from "react-toastify";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVNextFollowUpPlan from "@pages/candidate/list/DVTJCUVNextFollowUpPlan";
import {showMessage} from "@app/constants/Messages";

const InitSearchConditions = {
    'candidate_ids': '',
    'categories': {},
}

const DVTJCUVEmailFollowUpModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [selectPipeline, setSelectPipeline] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [okPipelineIds, setOkPipelineIds] = useState([]);
    const [notOkPipelineIds, setNotOkPipelineIds] = useState([]);
    const [notOkPipelines, setNotOkPipelines] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [isCheckingFollowUp, setCheckingFollowUp] = useState(false);
    const [nextFollowUpPlan, setNextFollowUpPlan] = useState({
        fu_schedule_next_time: "1",
        fu_schedule_next_time_unit: "week",
        fu_strategy_next_time: "",
        todo_w_cdd_dvtjcuv: "To ME follow up"
    });

    const [ignoreConditions, setIgnoreConditions] = useState({
        ignore_condition_1: false,
        ignore_condition_2: false,
        ignore_condition_3: false,
    });

    const {candidateIds, isShow, onSearch, onClose} = props

    const fetchCandidateList = async (canIds) => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: searchConditions
        }

        const res = await requestCandidates(params);

        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    const checkFollowUp = async (cddIds) => {
        setCheckingFollowUp(true)
        requestCheckFollowUpDVTJCUV({candidate_ids: cddIds}).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const okIds = res.content.ok_pipeline_ids
                const notOkIds = res.content.not_ok_pipeline_ids
                setOkPipelineIds(okIds);
                setNotOkPipelineIds(notOkIds);
                setNotOkPipelines(res.content.not_ok_pipelines);
                if (notOkIds.length === 0) {
                    searchConditions.candidate_ids = candidateIds
                    fetchCandidateList()
                }
            } else {
                toast.error(res.message);
            }
            setCheckingFollowUp(false)
        })
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
        if (localStorage.getItem(LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN)) {
            setNextFollowUpPlan(JSON.parse(localStorage.getItem(LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN)))
        }

    },[])

    useEffect(() => {
        searchConditions.candidate_ids = candidateIds
        if (!isCheckingFollowUp) {
            checkFollowUp(candidateIds);
        }
    },[candidateIds])

    const onAddCategoryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions.categories[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions.categories[fieldName] = arr
            setSearchConditions({...searchConditions})
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveCategoryItem = (index, fieldName) => {
        let arr = cloneDeep(searchConditions.categories[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            searchConditions.categories[fieldName] = arr
            setSearchConditions({...searchConditions})
        }
    }

    const onCheckToAddCandidateIntoFUTabs = () => {
        requestAddCddToFollowUpTabDVTJCUV({candidate_ids: candidateIds, ignore_conditions: ignoreConditions}).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Xử lý check thành công.`);
                setTimeout(function() {
                    window.location.href = "/dvtjcuv/acquire-cdd#dvtjcuv-acquire-cdd-fu-email-tab";
                }, 1000);
            } else {
                showMessage(res.message, true, true)
            }
        })
    }

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({...item})
        setShowUpdatePipelineModal(true)
    }

    const onChangeNextFollowUpPlan = (data) => {
        setNextFollowUpPlan(data)
        localStorage.setItem(LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN, JSON.stringify(nextFollowUpPlan));
    }

    const onChangeIgnoreConditions = (event) => {
        ignoreConditions[event.target.name] = !ignoreConditions[event.target.name]
        setIgnoreConditions({...ignoreConditions});
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Follow up DVTJCUV</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto'}}>
                    {notOkPipelineIds.length > 0 &&
                        <div className={'card card-default'}>
                            <div className='card-header'>
                                <h3 className='card-title text-bold'>
                                    Danh sách nhóm ca dòng pipelines có cùng [FU Strategy (Next time)] và [FU Compaign (Next time)]
                                </h3>
                            </div>
                            <div className='card-body'>
                                <DVTJCUVPipelineTableList
                                    pipeLines={notOkPipelines}
                                    mode={DVTJCUVPipelineListMode.RUN_FOLLOW_UP}
                                    // hideColumns={hideColumns}
                                    // showBtnAddPipelineOnRefereeInput={showBtnAddPipelineOnRefereeInput}
                                    // onSort={onSort}
                                    // sortColumn={searchInput.sort_columns}
                                    onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                                    // onClose={(reload) => onCloseUpdatePipeLine(reload)}
                                />
                            </div>
                        </div>
                    }

                    {notOkPipelineIds.length === 0 && !isCheckingFollowUp && okPipelineIds.length > 0 &&
                        <>
                            <div className='card card-default'>
                                <div className='card-header'>
                                    <h3 className='card-title text-bold'>Industry & Function</h3>
                                    <div className='card-tools'>
                                        <button type='button'
                                                className='btn btn-primary btn-sm'
                                                onClick={() => fetchCandidateList()}
                                        >
                                            <i className='fas fa-search mr-2'/>
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div className='card-body row'>
                                    {CANDIDATE_CATEGORY_FIELDS.map((field, i) => {
                                        let fieldValue = searchConditions.categories[field.key] ? searchConditions.categories[field.key] : []
                                        if (field.key === 'industry_function') {
                                            return ""
                                        }
                                        return <div className='input-group col-sm-6 mt-3'>
                                            <label className={'w-100'}>{field.label}</label>
                                            <ReactChipInput
                                                classes="class1 class2 w-100"
                                                chips={fieldValue}
                                                onSubmit={value => onAddCategoryItem(value, field.key)}
                                                onRemove={index => onRemoveCategoryItem(index, field.key)}
                                            />
                                        </div>
                                    })}
                                </div>
                            </div>
                            <DVTJCUVNextFollowUpPlan onChange={(data) => onChangeNextFollowUpPlan(data)} nextFollowUpPlan={nextFollowUpPlan}/>
                            <div className={'card card-default'}>
                                <div className='card-header'>
                                    <h3 className='card-title text-bold w-100'>Danh sách Persons</h3>
                                </div>
                                <div className='card-body'>

                                    <CandidateListTable
                                        candidates={candidates}
                                        allCandidateIds={allCandidateIds}
                                        mode={CandidateListMode.CANDIDATE_LIST}
                                        totalCount={totalCount}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer >
                    {/*<div className={"w-100 row"}>*/}
                    {/*    <div className='col-sm-3'>*/}
                    {/*        <div className={"input-group row"}>*/}
                    {/*            <label>Bỏ qua điều kiện 1</label>*/}
                    {/*            <input type="checkbox" name={`ignore_condition_1`} className={"ml-2"}*/}
                    {/*                   defaultChecked={!!ignoreConditions.ignore_condition_1}*/}
                    {/*                   style={{height: 20, width: 20, verticalAlign: 'middle'}}*/}
                    {/*                   onChange={event => onChangeIgnoreConditions(event)}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className='col-sm-3'>*/}
                    {/*        <div className={"input-group row"}>*/}
                    {/*        <label>Bỏ qua điều kiện 2</label>*/}
                    {/*        <input type="checkbox" name={`ignore_condition_2`} className={"ml-2"}*/}
                    {/*               defaultChecked={!!ignoreConditions.ignore_condition_2}*/}
                    {/*               style={{height: 20, width: 20, verticalAlign: 'middle'}}*/}
                    {/*               onChange={event => onChangeIgnoreConditions(event)}*/}
                    {/*        />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className='col-sm-3'>*/}
                    {/*        <div className={"input-group row"}>*/}
                    {/*        <label>Bỏ qua điều kiện 3</label>*/}
                    {/*        <input type="checkbox" name={`ignore_condition_3`} className={"ml-2"}*/}
                    {/*               defaultChecked={!!ignoreConditions.ignore_condition_3}*/}
                    {/*               style={{height: 20, width: 20, verticalAlign: 'middle'}}*/}
                    {/*               onChange={event => onChangeIgnoreConditions(event)}*/}
                    {/*        />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className={'col-sm-3'}>*/}
                    {/*        <button type='button'*/}
                    {/*                className='btn btn-primary float-right'*/}
                    {/*                onClick={() => onCheckToAddCandidateIntoFUTabs()}>*/}
                    {/*            Check*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                </Modal.Footer>
            </Modal>

            {showUpdatePipelineModal &&
            <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                                        pipeLineInfo={selectPipeline}
                                        onClose={(reload) => setShowUpdatePipelineModal(false)}
            />
            }
        </>
    )
}

export default DVTJCUVEmailFollowUpModal;
